import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { DataSharingService } from '../../../services/data-sharing.service';
import { CompanyService } from '../../../services/company.service';
import { pluralMappings } from '../../../classes/i18n';
import { MessageService } from '../../../services/message.service';
import { HttpParams } from '@angular/common/http';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: 'magic-insights-generation',
  templateUrl: './magic-insights-generation.component.html',
  styleUrls: ['./magic-insights-generation.component.css'],
  standalone: false,
})
export class MagicInsightsGenerationComponent implements OnDestroy {
  @Input() modulesInfo: Record<string, any>[];
  @Input() numberOfCompaniesMatchingSearchParams: number = null;
  @Input() searchParams: HttpParams = null;
  selectedMagicModuleIds: number[] = [];
  selectedModuleId: number = null;
  pluralMappings = pluralMappings;
  maximumCompaniesToGenerateViaQuery = 50000;
  selectedMagicInsightsGenerateCount = null;

  @Output() onGenerate = new EventEmitter();

  constructor(
    private dataStore: DataSharingService,
    private companyService: CompanyService,
    private messageService: MessageService
  ) {}


  loadingState = this.companyService.isLoading;

  ngOnInit() {
    this.selectedModuleId =
      this.modulesInfo.length === 1 ? this.modulesInfo[0].id : null;
    this.handleSelectedModuleIdsChange();
  }

  ngOnDestroy(): void {
  }

  handleSelectedModuleIdsChange() {
    this.selectedMagicModuleIds = this.selectedModuleId ? [this.selectedModuleId] : null;
  }

  confirmGenerateMIForSelectedCompanies(): void {
    this.companyService
      .generateMagicInsights(
        this.selectedMagicModuleIds[0],
        this.searchParams,
        this.selectedMagicInsightsGenerateCount
      )
      .subscribe(response => {
        if (response.body.aira_run_id) {
          $('#magicInsightsGenerationModal').modal('hide');
          this.messageService.showInfo(
            'Magic Insights generation has been queued for the selected companies.',
            4000
          );
          this.onGenerate.emit();
        }
      });
  }




  // -------------- State components --------------
  get showUnlockBySearchMessage(): boolean {
    const isResultCountManageable =
      this.numberOfCompaniesMatchingSearchParams < this.maximumCompaniesToGenerateViaQuery ||
      this.numberOfCompaniesMatchingSearchParams === null;

    return !!this.searchParams && isResultCountManageable;
  }

  get showSelectionWarning(): boolean {
    const isResultCountOverLimit = this.numberOfCompaniesMatchingSearchParams > this.maximumCompaniesToGenerateViaQuery;
    const isSelectedCountInvalid = this.selectedMagicInsightsGenerateCount === null || this.selectedMagicInsightsGenerateCount > this.maximumCompaniesToGenerateViaQuery;

    return !!this.searchParams && isResultCountOverLimit && isSelectedCountInvalid;
  }

  get canConfirmGeneration(): boolean {
    if (this.loadingState.loadingGenerateMagicInsights) {
      return false;
    }

    if (this.searchParams) {
      const isResultCountValid =
        this.numberOfCompaniesMatchingSearchParams !== null &&
        this.numberOfCompaniesMatchingSearchParams <= this.maximumCompaniesToGenerateViaQuery;

      const isSelectedCountValid =
        this.selectedMagicInsightsGenerateCount !== null &&
        this.selectedMagicInsightsGenerateCount <= this.maximumCompaniesToGenerateViaQuery;

      return isResultCountValid || isSelectedCountValid;
    }

    return false;
  }

}
